module.exports = __webpack_public_path__ + "img/TechWorkspace.5a67270f.jpg";